// --------------------------------------------------------------
// Created On: 2021-10-12
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useMemo, useState } from "react";
import CompanyListItem from "./CompanyListItem/CompanyListItem";
import styles from "./CompanyList.module.scss";

// A list of companies that can be interacted with.
export default function CompanyList(props: Props): Component {
  const [filter, setFilter] = useState<string>("");
  const filteredCompanies = useMemo(
    () => getFilteredCompanies(props.companies, filter),
    [JSON.stringify(props.companies), filter]
  );

  // Returns a list of filtered companies.
  function getFilteredCompanies(companies: Company[], filter: string): Company[] {
    if (filter.length > 0) {
      return props.companies.filter((company) => company.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
    } else {
      return companies;
    }
  }

  return (
    <div className={styles.body}>
      <div className={`${styles.header} p-4`}>
        <div className="row align-items-top">
          <div className={`${styles.title} mb-4 col`}>
            <span className="align-top">Companies</span>
          </div>

          {/* Filter bar. */}
          <div className="input-group rounded">
            <input
              type="search"
              className="form-control rounded"
              placeholder="Filter results..."
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className={styles.list}>
        {/* Visible list of interactive companies. */}
        {filteredCompanies.map((company) => (
          <div key={company.companyId} className={`${styles.item} selectable-container`} data-test="company-list-item">
            <CompanyListItem companyId={company.companyId} name={company.name} isPackager={company.isPackager} />
          </div>
        ))}
      </div>
    </div>
  );
}

interface Company {
  companyId: number;
  name: string;
  code: string;
  isPackager: boolean;
}

interface Props {
  companies: Company[];
}
